module.exports = __webpack_public_path__ + "img/pattern-right.f2e7633b.svg";